<script>
export default {
  emits: ['redirectToEventEdit'],
  data() {
    return {
      eventInfo: null,
      dialog: false,
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.revertAction();
    },
    openDialog(eventInfo) {
      this.eventInfo = eventInfo;
      this.dialog = true;
    },
    revertAction() {
      this.eventInfo.revert();
    },
    redirectToEditEvent() {
      let event = this.eventInfo.event;
      this.$emit('redirectToEventEdit', event);
    },
  }
}
</script>

<template>

  <Toast position="top-center" group="global" />

  <Dialog v-model:visible="dialog" modal header="Je probeert een herhaalde activiteit te wijzigen." :style="{ width: '32rem' }" :closeOnEscape="false" :closable="false">

    <span class="text-surface-500 dark:text-surface-400 block mb-8">Je wijzigt de datum en/of tijd van een herhaalde activiteit. Je kunt deze alleen wijzigen via het bewerk formulier.</span>

    <div class="flex justify-end gap-2">
      <Button type="button" label="Annuleren" severity="secondary" @click="closeDialog"></Button>
      <Button type="button" label="Bewerk" severity="primary" @click="redirectToEditEvent"></Button>
    </div>
  </Dialog>

</template>

<style>
 /* See agenda.scss for styling. Styling is here because we want the Gin/Bootstrap variables. */
</style>
